import styled from 'styled-components';

const Bubble = styled.span`
	padding: 0.4rem 0.8rem;
	display: block;

	font-size: 1.2rem;
	font-weight: 500;

	text-align: center;

	border-radius: 100px;
	border: 1px solid;
`;

export const BubbleGrey = styled(Bubble)`
	background-color: ${({ theme }) => theme.bubble_grey_bg};
	color: ${({ theme }) => theme.bubble_grey_fg};
	border-color: ${({ theme }) => theme.bubble_grey_border};
`;

export const BubbleWhite = styled(Bubble)`
	background-color: ${({ theme }) => theme.bubble_white_bg};
	color: ${({ theme }) => theme.bubble_white_fg};
	border-color: ${({ theme }) => theme.bubble_white_border};
`;

export const BubbleRed = styled(Bubble)`
	background-color: ${({ theme }) => theme.bubble_red_bg};
	color: ${({ theme }) => theme.bubble_red_fg};
	border-color: ${({ theme }) => theme.bubble_red_border};
`;
